export type ProcessesCalendarEntryQueryTranslation = {
  bookingModeError: string;
  datePlaceholder: string;
  dictionaryEntry: string;
  dictionaryEntryPlaceholder: string;
  dictionaryType: string;
  dictionaryTypeFirst: string;
  dictionaryTypePlaceholder: string;
  dictionaryTypeRequired: string;
  from: string;
  rangeIncomplete: string;
  sectionHint: string;
  sectionTitle: string;
  to: string;
};

export const processesCalendarEntryQueryTranslation: ProcessesCalendarEntryQueryTranslation = {
  bookingModeError:
    'Nie udało się wczytać trybu rezerwacji typu słownika. Formularza nie można zapisać z terminem.',
  datePlaceholder: 'Wybierz datę',
  dictionaryEntry: 'Element słownika',
  dictionaryEntryPlaceholder: 'Wybierz element',
  dictionaryType: 'Typ słownika',
  dictionaryTypeFirst: 'Najpierw wybierz typ słownika',
  dictionaryTypePlaceholder: 'Wybierz typ',
  dictionaryTypeRequired: 'Element słownika wymaga wybrania typu słownika.',
  from: 'Termin od',
  rangeIncomplete: 'Podaj obie granice terminu albo żadnej.',
  sectionHint: 'Opcjonalnie: element słownika i termin, o które pyta klient.',
  sectionTitle: 'Zapytany termin/zasób',
  to: 'Termin do',
};
